// Instância global do Notyf para reutilização
let notyfInstance = null;

/**
 * Função helper para exibir notificações usando Notyf
 * @param {string} message - Mensagem a ser exibida
 * @param {string} type - Tipo da notificação: 'success', 'error', 'info' (padrão: 'info')
 */
export function showNotification(message, type = 'info') {
    if (typeof window === 'undefined') {
        console.error('showNotification: window não está disponível');
        return;
    }

    // Aguardar Notyf estar disponível (pode demorar um pouco para carregar)
    if (!window.Notyf) {
        // Tentar novamente após um pequeno delay
        setTimeout(() => {
            if (window.Notyf) {
                showNotification(message, type);
            } else {
                // Se ainda não carregou, apenas loga no console e não usa alert
                console.warn('Notyf não está disponível para exibir a mensagem:', message);
            }
        }, 100);
        return;
    }

    // Criar instância única do Notyf se ainda não existir
    if (!notyfInstance) {
        try {
            notyfInstance = new window.Notyf({
                position: {
                    x: 'right',
                    y: 'top',
                },
                duration: 4000,
                types: [
                    {
                        type: 'info',
                        background: '#0274d8',
                        dismissible: true
                    },
                    {
                        type: 'error',
                        background: '#dc3545',
                        dismissible: true
                    },
                    {
                        type: 'success',
                        background: '#28a745',
                        dismissible: true
                    }
                ]
            });
        } catch (error) {
            console.error('Erro ao criar instância do Notyf:', error, 'Mensagem:', message);
            return;
        }
    }

    try {
        notyfInstance.open({
            type: type,
            message: message
        });
    } catch (error) {
        console.error('Erro ao exibir notificação:', error, 'Mensagem:', message);
    }
}

